import {XAxisOptions, YAxisOptions} from "highcharts";

const defaultAxisOptions = {
    labels: {enabled: false},
    title: {text: ""},
    gridLineWidth: 1,
    gridLineColor: "#F2F2F2"
};

export const getDefaultXAxisOptions = (): Partial<XAxisOptions> => {
    return {...defaultAxisOptions, tickWidth: 0, lineWidth: 0, minPadding: 0.02};
};

export const getDefaultYAxisOptions = (): Partial<YAxisOptions> => {
    return {...defaultAxisOptions};
};
import {XAxisOptions, YAxisOptions} from "highcharts";

const defaultAxisOptions = {
    labels: {enabled: false},
    title: {text: ""},
    gridLineWidth: 1,
    gridLineColor: "#F2F2F2"
};

export const getDefaultXAxisOptions = (): Partial<XAxisOptions> => {
    return {...defaultAxisOptions, tickWidth: 0, lineWidth: 0, minPadding: 0.02};
};

export const getDefaultYAxisOptions = (): Partial<YAxisOptions> => {
    return {...defaultAxisOptions};
};
